export enum FeedbackType {
    utilization = "utilization",
    bug = "bug",
    subscriptionrequest = "subscriptionrequest",
    messagesent = "messagesent",
    datadeletionrequest = "datadeletionrequest",
    airelated = "airelated",
    suggestions = "suggestions",
}

export const getFeedbackAsString = (feedbackType: FeedbackType): string => {
    switch (feedbackType) {
      case FeedbackType.utilization:
        return '💡 Question sur l’utilisation';
      case FeedbackType.bug:
        return '⚠️ Quelque chose ne fonctionne pas comme prévu'; // 🐞 Bug ou dysfonctionnement
      case FeedbackType.subscriptionrequest:
        return '📄 Abonnement / compte'; // 📦 Demande liée à mon abonnement
      case FeedbackType.airelated:
        return '🤖 IA, scénarios ou messages'; // 🧠 Question sur l’IA ou les scénarios
      case FeedbackType.suggestions:
        return '🚀 Suggestion ou idée d’amélioration' // 🚀 Suggestion d’amélioration
      default:
        return ''
    }
  };